module.exports = __webpack_public_path__ + "static/media/TUSD.1070353c9eb4aa4d6d3f82962d3b6c07.svg";